export const jobTypes = ["Hourly", "Daily", "Weekly"];
export const scheduleStatus = [
  "Completed",
  "Created",
  "Inprogress",
  "Failed",
  "Paused",
  "Resumed",
  "Updated",
  "Scheduled",
];
export const reportStatus = ["Completed", "Created", "Inprogress", "Failed"];
export const responseStatus = ["ContainerNotFound", "Scheduled", "Updated"];
